import { STATS } from '../data';

const FEATURES = [
  {
    cls: 'ic-blue',
    title: 'Voice recognition',
    body: 'Press, speak, and let go. Klingua hears you accurately and turns your voice into instant translation.',
    icon: (
      <path fill="currentColor" d="M12 15a3 3 0 0 0 3-3V6a3 3 0 1 0-6 0v6a3 3 0 0 0 3 3Zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.92V22h2v-3.08A7 7 0 0 0 19 12h-2Z"/>
    ),
  },
  {
    cls: 'ic-red',
    title: 'Fast translation',
    body: 'Modern speech APIs return a natural translation in under a second — fast enough for real back-and-forth.',
    icon: (
      <path fill="currentColor" d="M13 2 4.5 12.5h6L9 22l9.5-11.5h-6L13 2Z"/>
    ),
  },
  {
    cls: 'ic-violet',
    title: 'Built for everyone',
    body: 'Color-coded sides, big buttons, and spoken replies make Klingua effortless — red for one language, blue for the other.',
    icon: (
      <path fill="currentColor" d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 2c-4.4 0-8 2.2-8 5v1h16v-1c0-2.8-3.6-5-8-5Z"/>
    ),
  },
];

export default function Features() {
  return (
    <section className="section" id="features">
      <div className="container">
        <div className="stats" style={{ marginBottom: 64 }}>
          {STATS.map((s) => (
            <div className="stat" key={s.l}>
              <div className="n">{s.n}</div>
              <div className="l">{s.l}</div>
            </div>
          ))}
        </div>

        <div className="section-head">
          <span className="eyebrow">Why Klingua</span>
          <h2>Translation that keeps up with the conversation</h2>
          <p>No menus, no typing — just talk and be understood.</p>
        </div>

        <div className="features-grid">
          {FEATURES.map((f) => (
            <div className="feature" key={f.title}>
              <div className={'ic ' + f.cls}>
                <svg viewBox="0 0 24 24">{f.icon}</svg>
              </div>
              <h3>{f.title}</h3>
              <p>{f.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
